export default function pageGraphics(renderer, page, pageNr, fillColor, textColor) {
  const {width, height} = page;
  const pageTexture = new PIXI.Graphics()
    .beginFill(fillColor, 1)
    .drawRect(0, 0, width, height)
    .endFill()
    .lineStyle(1, textColor, 1)
    .moveTo(width / 5, height / 5)
    .lineTo(width - width / 5, height / 5)
    .moveTo(width / 2, height / 5)
    .lineTo(width / 2, height / 3);

  const pageText = new PIXI.Text(pageNr, {
    fontSize: Math.min(Math.max(Math.min(width, height) / 1.8, 1), 24)
  });
  pageText.anchor.set(0.5);
  pageText.x = width / 2;
  pageText.y = height / 2;

  pageTexture.addChild(pageText);

  return renderer.generateTexture(pageTexture);
}


// WEBPACK FOOTER //
// ./src/views/SheetCalculator/Pixi/pageGraphics.js